import {Component, HostBinding} from '@angular/core';

@Component({
    selector: 'pr-shops-details-wrapper',
    templateUrl: './shops-details-wrapper.component.html',
})
export class ShopsDetailsWrapperComponent {
    @HostBinding('class.flex')
    @HostBinding('class.flex-grow')

    tabLinks = [
        { 'path': './details', 'label': 'Szczegóły placówki' },
        { 'path': './floorplan', 'label': 'Floorplan' }
    ];

}
